export default "__VITE_ASSET__Bi9i1FVE__"